const pathAPI = `${process.env.REACT_APP_SERVICE_PATH_OSP}/api/msisdn/app`;

export const apiProduct = {
  searchSim: `${pathAPI}/filter`,
  detailSim: `${pathAPI}/detail`,
  searchCategory: `${pathAPI}/category/filter`,
  lockSim: `${pathAPI}/lock`,
};
